export const pulseNChillRewardItems = [
    {
      name: 'Ghc 5,000',
      tag: '1st',
      id: 'kfc',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 2,500',
      tag: '2nd',
      id: 'potbelly',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 1,500',
      tag: '3rd',
      id: 'shoprite',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 1,000',
      tag: '4th-53rd',
      id: 'melcom-voucher',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 400',
      tag: '54th-153rd',
      id: 'kfc',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 300',
      tag: '154th-253rd',
      id: 'potbelly',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 200',
      tag: '254th-353rd',
      id: 'shoprite',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 100',
      tag: '354th-653rd',
      id: 'melcom-voucher',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
    {
      name: 'Ghc 50',
      tag: '654th-753rd',
      id: 'melcom-voucher',
      amount: 50,
      image: '/assets/images/cash.jpg'
    },
  ];


